export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV-后半段" transform="translate(-773.000000, -4339.000000)">
                    <g id="编组-15备份" transform="translate(0.000000, 168.000000)">
                        <g id="-mockplus-" transform="translate(449.000000, 4157.000000)">
                            <g id="编组-13备份" transform="translate(324.000000, 14.000000)">
                                <circle id="椭圆形" fill="#000000" cx="13" cy="13" r="13"></circle>
                                <path
                                    d="M13.8666667,7.8 L13.866,12.133 L18.2,12.1333333 L18.2,13.8666667 L13.866,13.866 L13.8666667,18.2 L12.1333333,18.2 L12.133,13.866 L7.8,13.8666667 L7.8,12.1333333 L12.133,12.133 L12.1333333,7.8 L13.8666667,7.8 Z"
                                    id="形状结合"
                                    fill="#FFFFFF"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
